import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Travel Destination Flow Component
const TravelDestinationFlow = ({ isDesktop = false }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedDestination, setSelectedDestination] = useState(null);
  
  const destinations = [
    {
      id: 1,
      name: "SAUDI ARABIA",
      image: "/assets/sau.png",
      offer: "UP TO 30% OFF",
      subtitle: "ON FLIGHTS TO SAUDI ARABIA",
      color: "from-blue-500 to-blue-600",
      bgImage: "/assets/sau.png"
    },
    {
      id: 2,
      name: "DUBAI",
      image: "/assets/du.jpg",
      offer: "UP TO 30% OFF",
      subtitle: "ON FLIGHTS TO DUBAI",
      color: "from-amber-500 to-amber-600",
      bgImage: "/assets/du.jpg"
    },
    {
      id: 3,
      name: "ABU DHABI",
      image: "/assets/dha.jpg",
      offer: "UP TO 30% OFF",
      subtitle: "ON FLIGHTS TO ABU DHABI",
      color: "from-purple-500 to-purple-600",
      bgImage: "/assets/dha.jpg"
    }
  ];

  const handleDestinationSelect = (destination) => {
    setSelectedDestination(destination);
    setCurrentStep(2);
  };

  const handleBookNow = () => {
    setCurrentStep(3);
    // Simulate redirect to booking
    setTimeout(() => {
      setCurrentStep(1);
      setSelectedDestination(null);
    }, 2000);
  };

  const resetFlow = () => {
    setCurrentStep(1);
    setSelectedDestination(null);
  };

  // Step 1: Home Screen with Destination Selection
  const HomeScreen = () => (
    <div className="h-80 bg-gradient-to-br from-gray-900 via-gray-900 to-gray-900 flex flex-col relative overflow-hidden font-serif">
      {/* Background Image */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url('/assets/nn.jpeg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>
      
      {/* Mosque silhouette overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-slate-900 to-transparent z-5">
        <div className="absolute bottom-0 left-0 right-0 h-32 opacity-40">
          <svg viewBox="0 0 400 100" className="w-full h-full">
            <path d="M0,100 Q50,60 100,70 T200,65 T300,70 T400,65 L400,100 Z" fill="#1e293b" />
            <circle cx="80" cy="45" r="8" fill="#1e293b" />
            <circle cx="200" cy="40" r="10" fill="#1e293b" />
            <circle cx="320" cy="50" r="6" fill="#1e293b" />
            <rect x="78" y="45" width="4" height="20" fill="#1e293b" />
            <rect x="198" y="40" width="4" height="25" fill="#1e293b" />
            <rect x="318" y="50" width="4" height="15" fill="#1e293b" />
          </svg>
        </div>
      </div>

      {/* Header */}
      {/* <div className={`relative z-10 ${isDesktop ? 'pt-2 pb-2' : 'pt-2 pb-2'} px-6`}>
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center space-x-2">
            <div className={`${isDesktop ? 'w-12 h-12' : 'w-10 h-10'} bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center`}>
              <span className={`text-white font-bold ${isDesktop ? 'text-xl' : 'text-lg'}`}>T</span>
            </div>
            <div>
              <h1 className={`text-white ${isDesktop ? 'text-lg' : 'text-lg'} font-bold`}>traveloka</h1>
              <div className="flex items-center space-x-1">
                <span className="text-yellow-400 text-xs">★</span>
                <span className="text-white text-xs opacity-75">Premium Travel</span>
              </div>
            </div>
          </div>
          <div className="text-white opacity-75">
            <div className={`${isDesktop ? 'w-10 h-10' : 'w-8 h-8'} flex items-center justify-center`}>
              <span className={`${isDesktop ? 'text-3xl' : 'text-2xl'}`}>🌙</span>
            </div>
          </div>
        </div>

        <div className="text-center mb-1">
          <h2 className={`text-white ${isDesktop ? 'text-sm' : 'text-sm'} font-bold `}>Where Should You</h2>
          <h2 className={`text-white ${isDesktop ? 'text-sm' : 'text-sm'} font-bold mb-1`}>Go This Eid?</h2>
          <p className={`text-white/80 ${isDesktop ? 'text-sm' : 'text-sm'}`}>
            Click to select your destination and
           
            find your perfect getaway
          </p>
        </div>
      </div> */}
<div className={`relative z-10 ${isDesktop ? 'pt-2 pb-3' : 'pt-4 pb-3'} px-6` }>
  {/* Header row */}
  {/* <div className="flex items-center justify-center mb-3">
    <div className="flex items-center space-x-2">
  
      
      <div className='text-center'>
      <div className="flex items-center space-x-0">
 
  <h1 className={`text-white font-bold text-center ${isDesktop ? 'text-sm font-serif' : 'text-xl font-serif'}`}>
    traveloka
  </h1>
  <img
    src="/assets/bird.png" 
    alt="Traveloka Logo"
    className="w-8 h-6 object-contain" 
  />
</div>        <div className="flex items-center space-x-1">
         
          <span className="text-yellow-300 text-xs opacity-75  font-serif">Premium Travel</span>
        </div>
      </div>
    </div>
   
  </div> */}
<div className="flex items-center justify-center mb-3">
  <div className="flex items-center space-x-2">
    <div className="flex flex-col items-center text-center">
      <div className="flex items-center">
        <h1 className={`text-white font-bold ${isDesktop ? 'text-sm font-serif' : 'text-xl font-serif'}`}>
          traveloka
        </h1>
        <img
          src="/assets/bird.png"
          alt="Traveloka Logo"
          className="w-8 h-6 object-contain ml-1"
        />
      </div>
      <span className="text-yellow-300 text-xs opacity-75 font-serif">
        Premium Travel
      </span>
    </div>
  </div>
</div>

  {/* Title and subtitle */}
  <div className="text-center mb-2">
    <h2 className={`text-white ${isDesktop ? 'text-md' : 'text-xl'} font-serif font-semibold leading-snug`}>
      Where Should You
    </h2>
    <h2 className={`text-white ${isDesktop ? 'text-md' : 'text-xl'} font-serif font-semibold mb-2 leading-snug`}>
      Go This Eid?
    </h2>
    <p className={`text-white/80 ${isDesktop ? 'text-sm' : 'text-sm'} font-light`}>
      Tap to explore luxe escapes in these curated destinations.
    </p>
  </div>
</div>

      {/* Destination Cards - Responsive Layout */}
      <div className={`flex-1 px-6 pb-2 relative z-10`}>
        <div className={`grid ${isDesktop ? 'grid-cols-3 gap-6 max-w-4xl mx-auto' : 'grid-cols-3 gap-3'}`}>
          {destinations.map((destination) => (
            <div
              key={destination.id}
              onClick={() => handleDestinationSelect(destination)}
              className={`relative overflow-hidden rounded-2xl cursor-pointer transform hover:scale-105 transition-all duration-300 shadow-xl ${isDesktop ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}
            >
              <img 
                src={destination.image} 
                alt={destination.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className={`absolute bottom-0 left-0 right-0 ${isDesktop ? 'p-4' : 'p-3'}`}>
                <h3 className={`text-white ${isDesktop ? 'text-base' : 'text-xs'} font-medium text-center leading-tight`}>
                  {destination.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // Step 2: Offer Screen
  const OfferScreen = () => (
    <div className="h-96 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col relative overflow-hidden">
      {/* Background with selected destination image */}
      <div 
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage: `url('${selectedDestination.bgImage}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-slate-900/30"></div>
      
      {/* Header */}
      <div className={`relative z-10 ${isDesktop ? 'pt-1 pb-1' : 'pt-6 '} px-2`}>
        <div className="flex items-center justify-between ">
          <button 
            onClick={resetFlow}
            className={`text-white ${isDesktop ? 'text-2xl w-10 h-10' : 'text-xl w-4 h-4'} flex items-center justify-center hover:bg-white/10 rounded-lg transition-colors`}
          >
            ❮
          </button>
          {/* <div className="flex items-center space-x-1 mb-1">
            <div className={`${isDesktop ? 'w-4 h-4' : 'w-4 h-4'} bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center`}>
              <span className={`text-white font-bold ${isDesktop ? 'text-base' : 'text-sm'}`}>T</span>
            </div>
            <span className={`text-white ${isDesktop ? 'text-lg' : 'text-md'} font-bold`}>traveloka</span>
          </div> */}
             <div className="flex items-center space-x-0">
 
 <h1 className={`text-white font-bold ${isDesktop ? 'text-sm font-serif' : 'text-md font-serif'}`}>
   traveloka
 </h1>
 <img
   src="/assets/bird.png" // Replace with your actual image path
   alt="Traveloka Logo"
   className="w-8 h-6 object-contain" // Adjust size as needed
 />
</div>
          <div className={`${isDesktop ? 'w-12' : 'w-4'}`}></div>
        </div>
      </div>

      {/* Main Offer Content */}
      <div className={`flex-1 flex flex-col items-center justify-center px-3 relative z-10`}>
        <div className="text-center mb-2 mt-2">
          <div className={`${isDesktop ? 'w-32 h-32' : 'w-28 h-28'} rounded-2xl overflow-hidden  mx-auto shadow-2xl`}>
            <img 
              src={selectedDestination.image} 
              alt={selectedDestination.name}
              className="w-full h-full object-cover"
            />
          </div>
          <h2 className={`text-white ${isDesktop ? 'text-lg' : 'text-lg'} font-bold mb-1 mt-1`}>{selectedDestination.name}</h2>
          <div className={`bg-white/20 backdrop-blur-sm rounded-2xl ${isDesktop ? 'p-1' : 'p-1'} border border-white/30`}>
            <h3 className={`text-white ${isDesktop ? 'text-sm' : 'text-sm'} font-bold `}>{selectedDestination.offer}</h3>
            <p className={`text-white/90 ${isDesktop ? 'text-xs' : 'text-xs'}`}>{selectedDestination.subtitle}</p>
          </div>
        </div>

        {/* Book Now Button */}
        <button 
          onClick={handleBookNow}
          className={`bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold ${isDesktop ? 'py-1 px-1 text-sm ' : 'py-1 px-1 text-sm'} rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200`}
        >
          BOOK NOW
        </button>
      </div>

      {/* Bottom Navigation Hint */}
      <div className={`relative z-10 py-2 ${isDesktop ? 'pb-24' : 'pb-24'} px-6`}>
        <p className={`text-white/60 text-center ${isDesktop ? 'text-sm' : 'text-sm'}`}>
          * Limited time offer. Book now to secure your deal!
        </p>
      </div>
    </div>
  );

  // Step 3: Booking Redirect Screen
  const BookingScreen = () => (
    <div className="h-80 bg-gradient-to-br from-blue-300 to-green-500 flex flex-col items-center justify-center px-6 relative overflow-hidden">
      {/* Success Animation */}
      <div className="text-center">
        <div className={`${isDesktop ? 'text-3xl mb-1' : 'text-3xl mb-1'} animate-bounce`}>✈️</div>
        <h2 className={`text-white ${isDesktop ? 'text-3xl' : 'text-3xl'} font-bold mb-1`}>Redirecting...</h2>
        <p className={`text-white/90 ${isDesktop ? 'text-lg' : 'text-lg'} mb-1`}>
          Taking you to the booking website
        </p>
        <div className={`bg-white/20 backdrop-blur-sm rounded-2xl ${isDesktop ? 'p-8' : 'p-6'} border border-white/30 max-w-md mx-auto`}>
          <p className={`text-white ${isDesktop ? 'text-base' : 'text-sm'}`}>
            You'll be redirected to complete your booking for {selectedDestination.name}
          </p>
        </div>
      </div>

      {/* Loading Dots */}
      <div className="flex space-x-2 mt-8">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={`${isDesktop ? 'w-4 h-4' : 'w-3 h-3'} bg-white rounded-full animate-bounce`}
            style={{ animationDelay: `${i * 0.2}s` }}
          ></div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="w-full h-full">
      {currentStep === 1 && <HomeScreen />}
      {currentStep === 2 && <OfferScreen />}
      {currentStep === 3 && <BookingScreen />}
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>
       <Helmet>
       <title>
        Traveloka Campaign | Interactive Selector Ad Showcase
        </title>
        <meta
          name="description"
          content="See how Traveloka leverages Interactive Selector ads with Bidbox. Explore engaging ad formats that boost interaction & inspire travel choices."
        />
        {/* <meta
          name="keywords"
          content="Discover how Recard campaigns run in CTV Quiz ads. Explore Bidbox’s creative retargeting strategies that boost engagement & conversions."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/interactive-selector/travel-ramadan"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-8 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Pick a Place. Unlock the Escape.
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Interactive Selector
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                  MAKE IT YOURS!
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This travel experience Ad lets users pick from three destinations, each click instantly reveals a custom deal tied to their selection, making the journey feel personal from the start. Just add your visuals, offers, and branding to launch a personalized, high-conversion travel flow.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative bg-gray-200 rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          travel-destinations.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        {/* Travel Flow - Full screen on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                  </div>
                        <div className="mb-6">
                          <div className="relative group transform transition-all duration-300 rounded-lg overflow-hidden">
                            <TravelDestinationFlow isDesktop={false} />
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-4xl mx-auto hidden lg:block">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-2">
                          <div className="bg-white rounded-md px-2 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 travel-destinations.com
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="p-2 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar ">
                        {/* Travel Flow centered on desktop */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>
                        <div className="flex justify-center">
                          <div className="w-full max-w-md">
                            <TravelDestinationFlow isDesktop={true} />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
      `}</style>
    </div>

    <div className="max-w-7xl mx-auto px-4 py-10">
          <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
    
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {/* Card 1 */}
            <Link to="/scratch-to-win/hm" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/sc.avif"
                alt="Card 1"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Scratch TO Win</h2>
              </div>
            </Link>
    
            {/* Card 2 */}
            <Link to="/swipe-to-reveal/pizza" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/sw.jpg"
                alt="Card 2"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Swipe to Reveal</h2>
              </div>
            </Link>
    
            {/* Card 3 */}
            <Link to="/tap-to-reveal/thumsup" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/tmmm.png"
                alt="Card 3"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Tap to Reveal</h2>
              </div>
            </Link>
    
            {/* Card 4 */}
            <Link to="/tap-to-reveal/ps" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/ps.avif"
                alt="Card 4"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">PS 5</h2>
              </div>
            </Link>
    
           
          </div>
        </div>
    </>
  );
}

export default App;

// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Copy, Play, Pause, Maximize2, Download, Share2, Eye, Settings, Monitor, Smartphone, Gift, Sparkles, Zap, Target, RotateCcw } from 'lucide-react';

// // Travel Destination Flow Component
// const TravelDestinationFlow = ({ isDesktop = false }) => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [selectedDestination, setSelectedDestination] = useState(null);
  
//   const destinations = [
//     {
//       id: 1,
//       name: "SAUDI ARABIA",
//       image: "https://images.pexels.com/photos/19540938/pexels-photo-19540938/free-photo-of-kingdom-centre-tower-in-riyadh-saudi-arabia.jpeg?auto=compress&cs=tinysrgb&w=800",
//       offer: "UP TO 30% OFF",
//       subtitle: "ON FLIGHTS TO SAUDI ARABIA",
//       color: "from-blue-500 to-blue-600",
//       bgImage: "https://images.pexels.com/photos/19540938/pexels-photo-19540938/free-photo-of-kingdom-centre-tower-in-riyadh-saudi-arabia.jpeg?auto=compress&cs=tinysrgb&w=1200"
//     },
//     {
//       id: 2,
//       name: "DUBAI",
//       image: "https://images.pexels.com/photos/162031/dubai-tower-arab-khalifa-162031.jpeg?auto=compress&cs=tinysrgb&w=800",
//       offer: "UP TO 30% OFF",
//       subtitle: "ON FLIGHTS TO DUBAI",
//       color: "from-amber-500 to-amber-600",
//       bgImage: "https://images.pexels.com/photos/162031/dubai-tower-arab-khalifa-162031.jpeg?auto=compress&cs=tinysrgb&w=1200"
//     },
//     {
//       id: 3,
//       name: "ABU DHABI",
//       image: "https://images.pexels.com/photos/2115367/pexels-photo-2115367.jpeg?auto=compress&cs=tinysrgb&w=800",
//       offer: "UP TO 30% OFF",
//       subtitle: "ON FLIGHTS TO ABU DHABI",
//       color: "from-purple-500 to-purple-600",
//       bgImage: "https://images.pexels.com/photos/2115367/pexels-photo-2115367.jpeg?auto=compress&cs=tinysrgb&w=1200"
//     }
//   ];

//   const handleDestinationSelect = (destination) => {
//     setSelectedDestination(destination);
//     setCurrentStep(2);
//   };

//   const handleBookNow = () => {
//     setCurrentStep(3);
//     // Simulate redirect to booking
//     setTimeout(() => {
//       setCurrentStep(1);
//       setSelectedDestination(null);
//     }, 2000);
//   };

//   const resetFlow = () => {
//     setCurrentStep(1);
//     setSelectedDestination(null);
//   };

//   // Step 1: Home Screen with Destination Selection
//   const HomeScreen = () => (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col relative overflow-hidden">
//       {/* Background Image */}
//       <div 
//         className="absolute inset-0 opacity-30"
//         style={{
//           backgroundImage: `url('https://images.pexels.com/photos/1285625/pexels-photo-1285625.jpeg?auto=compress&cs=tinysrgb&w=1200')`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center'
//         }}
//       ></div>
      
//       {/* Mosque silhouette overlay */}
//       <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-slate-900 to-transparent z-5">
//         <div className="absolute bottom-0 left-0 right-0 h-32 opacity-40">
//           <svg viewBox="0 0 400 100" className="w-full h-full">
//             <path d="M0,100 Q50,60 100,70 T200,65 T300,70 T400,65 L400,100 Z" fill="#1e293b" />
//             <circle cx="80" cy="45" r="8" fill="#1e293b" />
//             <circle cx="200" cy="40" r="10" fill="#1e293b" />
//             <circle cx="320" cy="50" r="6" fill="#1e293b" />
//             <rect x="78" y="45" width="4" height="20" fill="#1e293b" />
//             <rect x="198" y="40" width="4" height="25" fill="#1e293b" />
//             <rect x="318" y="50" width="4" height="15" fill="#1e293b" />
//           </svg>
//         </div>
//       </div>

//       {/* Header */}
//       <div className={`relative z-10 ${isDesktop ? 'pt-20 pb-8' : 'pt-16 pb-4'} px-6`}>
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center space-x-3">
//             <div className={`${isDesktop ? 'w-12 h-12' : 'w-10 h-10'} bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center`}>
//               <span className={`text-white font-bold ${isDesktop ? 'text-xl' : 'text-lg'}`}>T</span>
//             </div>
//             <div>
//               <h1 className={`text-white ${isDesktop ? 'text-2xl' : 'text-xl'} font-bold`}>traveloka</h1>
//               <div className="flex items-center space-x-1">
//                 <span className="text-yellow-400 text-xs">★</span>
//                 <span className="text-white text-xs opacity-75">Premium Travel</span>
//               </div>
//             </div>
//           </div>
//           <div className="text-white opacity-75">
//             <div className={`${isDesktop ? 'w-10 h-10' : 'w-8 h-8'} flex items-center justify-center`}>
//               <span className={`${isDesktop ? 'text-3xl' : 'text-2xl'}`}>🌙</span>
//             </div>
//           </div>
//         </div>

//         <div className="text-center mb-8">
//           <h2 className={`text-white ${isDesktop ? 'text-4xl' : 'text-2xl'} font-bold mb-2`}>Where Should You</h2>
//           <h2 className={`text-white ${isDesktop ? 'text-4xl' : 'text-2xl'} font-bold mb-4`}>Go This Eid?</h2>
//           <p className={`text-white/80 ${isDesktop ? 'text-base' : 'text-sm'}`}>
//             Click to select your destination and
//             <br />
//             find your perfect getaway
//           </p>
//         </div>
//       </div>

//       {/* Destination Cards - Responsive Layout */}
//       <div className={`flex-1 px-6 pb-8 relative z-10`}>
//         <div className={`grid ${isDesktop ? 'grid-cols-3 gap-6 max-w-4xl mx-auto' : 'grid-cols-3 gap-3'}`}>
//           {destinations.map((destination) => (
//             <div
//               key={destination.id}
//               onClick={() => handleDestinationSelect(destination)}
//               className={`relative overflow-hidden rounded-2xl cursor-pointer transform hover:scale-105 transition-all duration-300 shadow-xl ${isDesktop ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}
//             >
//               <img 
//                 src={destination.image} 
//                 alt={destination.name}
//                 className="w-full h-full object-cover"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
//               <div className={`absolute bottom-0 left-0 right-0 ${isDesktop ? 'p-4' : 'p-3'}`}>
//                 <h3 className={`text-white ${isDesktop ? 'text-base' : 'text-sm'} font-bold text-center leading-tight`}>
//                   {destination.name}
//                 </h3>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );

//   // Step 2: Offer Screen
//   const OfferScreen = () => (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col relative overflow-hidden">
//       {/* Background with selected destination image */}
//       <div 
//         className="absolute inset-0 opacity-40"
//         style={{
//           backgroundImage: `url('${selectedDestination.bgImage}')`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center'
//         }}
//       ></div>
//       <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-slate-900/30"></div>
      
//       {/* Header */}
//       <div className={`relative z-10 ${isDesktop ? 'pt-20 pb-8' : 'pt-4 '} px-2`}>
//         <div className="flex items-center justify-between mb-1">
//           <button 
//             onClick={resetFlow}
//             className={`text-white ${isDesktop ? 'text-3xl w-12 h-12' : 'text-xl w-4 h-4'} flex items-center justify-center hover:bg-white/10 rounded-lg transition-colors`}
//           >
//             ❮
//           </button>
//           <div className="flex items-center space-x-1">
//             <div className={`${isDesktop ? 'w-10 h-10' : 'w-4 h-4'} bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center`}>
//               <span className={`text-white font-bold ${isDesktop ? 'text-base' : 'text-sm'}`}>T</span>
//             </div>
//             <span className={`text-white ${isDesktop ? 'text-xl' : 'text-md'} font-bold`}>traveloka</span>
//           </div>
//           <div className={`${isDesktop ? 'w-12' : 'w-4'}`}></div>
//         </div>
//       </div>

//       {/* Main Offer Content */}
//       <div className={`flex-1 flex flex-col items-center justify-center px-3 relative z-10`}>
//         <div className="text-center mb-1">
//           <div className={`${isDesktop ? 'w-48 h-48' : 'w-28 h-28'} rounded-2xl overflow-hidden mb-1 mx-auto shadow-2xl`}>
//             <img 
//               src={selectedDestination.image} 
//               alt={selectedDestination.name}
//               className="w-full h-full object-cover"
//             />
//           </div>
//           <h2 className={`text-white ${isDesktop ? 'text-xl' : 'text-xl'} font-bold mb-1`}>{selectedDestination.name}</h2>
//           <div className={`bg-white/20 backdrop-blur-sm rounded-2xl ${isDesktop ? 'p-6' : 'p-4'} border border-white/30`}>
//             <h3 className={`text-white ${isDesktop ? 'text-md' : 'text-md'} font-bold mb-1`}>{selectedDestination.offer}</h3>
//             <p className={`text-white/90 ${isDesktop ? 'text-md' : 'text-md'}`}>{selectedDestination.subtitle}</p>
//           </div>
//         </div>

//         {/* Book Now Button */}
//         <button 
//           onClick={handleBookNow}
//           className={`bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold ${isDesktop ? 'py-2 px-4 text-xl' : 'py-1 px-2 text-lg'} rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200`}
//         >
//           BOOK NOW
//         </button>
//       </div>

//       {/* Bottom Navigation Hint */}
//       <div className={`relative z-10 ${isDesktop ? 'pb-24' : 'pb-24'} px-6`}>
//         <p className={`text-white/60 text-center ${isDesktop ? 'text-base' : 'text-sm'}`}>
//           * Limited time offer. Book now to secure your deal!
//         </p>
//       </div>
//     </div>
//   );

//   // Step 3: Booking Redirect Screen
//   const BookingScreen = () => (
//     <div className="min-h-screen bg-gradient-to-br from-green-600 to-green-700 flex flex-col items-center justify-center px-6 relative overflow-hidden">
//       {/* Success Animation */}
//       <div className="text-center">
//         <div className={`${isDesktop ? 'text-4xl mb-1' : 'text-4xl mb-1'} animate-bounce`}>✈️</div>
//         <h2 className={`text-white ${isDesktop ? 'text-4xl' : 'text-3xl'} font-bold mb-1`}>Redirecting...</h2>
//         <p className={`text-white/90 ${isDesktop ? 'text-xl' : 'text-lg'} mb-1`}>
//           Taking you to the booking website
//         </p>
//         <div className={`bg-white/20 backdrop-blur-sm rounded-2xl ${isDesktop ? 'p-8' : 'p-6'} border border-white/30 max-w-md mx-auto`}>
//           <p className={`text-white ${isDesktop ? 'text-base' : 'text-sm'}`}>
//             You'll be redirected to complete your booking for {selectedDestination.name}
//           </p>
//         </div>
//       </div>

//       {/* Loading Dots */}
//       <div className="flex space-x-2 mt-8">
//         {[0, 1, 2].map((i) => (
//           <div
//             key={i}
//             className={`${isDesktop ? 'w-4 h-4' : 'w-3 h-3'} bg-white rounded-full animate-bounce`}
//             style={{ animationDelay: `${i * 0.2}s` }}
//           ></div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <div className="w-full h-full">
//       {currentStep === 1 && <HomeScreen />}
//       {currentStep === 2 && <OfferScreen />}
//       {currentStep === 3 && <BookingScreen />}
//     </div>
//   );
// };

// export default function TravelDestinationMockup() {
//     const [selectedDevice, setSelectedDevice] = useState('Mobile');
//     const [isPlaying, setIsPlaying] = useState(false);

//     return (
//         <div className="mt-14 min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-teal-50 p-4 lg:p-6">
//             {/* Header */}
//             <div className="mb-6 lg:mb-8">
//                 <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
//                     <div>
//                         <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">Travel Destination Campaign</h1>
//                         <p className="text-gray-600 text-sm lg:text-base">Interactive travel destination selection and booking flow</p>
//                     </div>
//                     <div className="flex items-center gap-3">
//                         <button className="px-3 py-2 lg:px-4 lg:py-2 bg-white rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors flex items-center gap-2 text-sm lg:text-base">
//                             <Settings className="h-4 w-4" />
//                             Settings
//                         </button>
//                         <button className="px-3 py-2 lg:px-4 lg:py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 text-sm lg:text-base">
//                             <Share2 className="h-4 w-4" />
//                             Share
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-6">
//                 {/* Left Sidebar - Project Info */}
//                 <div className="lg:col-span-1 order-2 lg:order-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6 mb-4 lg:mb-6">
//                         <div className="flex items-center gap-3 mb-4">
//                             <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-blue-500 to-teal-600 rounded-xl flex items-center justify-center">
//                                 <span className="h-5 w-5 lg:h-6 lg:w-6 text-white text-xl">✈️</span>
//                             </div>
//                             <div>
//                                 <h2 className="text-base lg:text-lg font-semibold text-gray-900">Eid Travel</h2>
//                                 <p className="text-xs lg:text-sm text-gray-500">ID: 456789</p>
//                             </div>
//                         </div>
                        
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Status</span>
//                                 <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">Live</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Campaign</span>
//                                 <span className="text-xs lg:text-sm text-gray-900">Eid 2024</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Updated</span>
//                                 <span className="text-xs lg:text-sm text-gray-900">30 min ago</span>
//                             </div>
//                         </div>

//                         <button className="w-full mt-4 text-blue-600 hover:text-blue-700 text-xs lg:text-sm font-medium">
//                             View Campaign Analytics
//                         </button>
//                     </div>

//                     {/* Quick Actions */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6">
//                         <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
//                         <div className="space-y-3">
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Download className="h-4 w-4" />
//                                 Export Creative
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Copy className="h-4 w-4" />
//                                 Copy Ad Tag
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Maximize2 className="h-4 w-4" />
//                                 Fullscreen Test
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Center Content - Preview Area */}
//                 <div className="lg:col-span-2 order-1 lg:order-2">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6">
//                         {/* Device Toggle */}
//                         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
//                             <div className="flex items-center gap-2">
//                                 <h3 className="text-base lg:text-lg font-semibold text-gray-900">Interactive Preview</h3>
//                                 <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors" />
//                             </div>
//                             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//                                 {[
//                                     { name: 'Mobile', icon: Smartphone },
//                                     { name: 'Desktop', icon: Monitor }
//                                 ].map(({ name, icon: Icon }) => (
//                                     <button
//                                         key={name}
//                                         className={`px-2 py-1 lg:px-3 lg:py-2 rounded-md text-xs lg:text-sm font-medium transition-all flex items-center gap-1 lg:gap-2 ${
//                                             selectedDevice === name
//                                                 ? 'bg-white text-blue-600 shadow-sm'
//                                                 : 'text-gray-600 hover:text-gray-900'
//                                         }`}
//                                         onClick={() => setSelectedDevice(name)}
//                                     >
//                                         <Icon className="h-3 w-3 lg:h-4 lg:w-4" />
//                                         {name}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Navigation */}
//                         <div className="flex items-center justify-between mb-6">
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors text-sm">
//                                 <ChevronLeft className="h-4 w-4" />
//                                 Previous Ad
//                             </button>
//                             <div className="flex items-center gap-2">
//                                 <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                             </div>
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors text-sm">
//                                 Next Ad
//                                 <ChevronRight className="h-4 w-4" />
//                             </button>
//                         </div>

//                         {/* Preview Container */}
//                         <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 lg:p-8 min-h-[400px] lg:min-h-[600px] flex items-center justify-center">
//                             {/* Device Frame */}
//                             <div className="relative">
//                                 {selectedDevice === 'Mobile' ? (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 to-teal-500/20 rounded-3xl blur-xl"></div>
//                                         <div className="relative bg-gray-900 rounded-3xl p-2 shadow-2xl">
//                                             <div className="bg-black rounded-2xl overflow-hidden">
//                                                 <div className="w-[280px] h-[500px] lg:w-[300px] lg:h-[560px] relative">
//                                                     <TravelDestinationFlow isDesktop={false} />
//                                                 </div>
//                                             </div>
//                                             <div className="w-16 h-1 lg:w-20 lg:h-1 bg-gray-600 rounded-full mx-auto mt-2"></div>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 to-teal-500/20 rounded-xl blur-xl"></div>
//                                         <div className="relative bg-white rounded-xl shadow-2xl p-4">
//                                             <div className="bg-gray-100 rounded-lg p-2">
//                                                 <div className="w-[320px] h-[600px] lg:w-[500px] lg:h-[700px] bg-black rounded overflow-hidden relative">
//                                                     <TravelDestinationFlow isDesktop={true} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                                 {/* Desktop Stand */}
//         <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-6">
//           <div className="w-40 h-8 bg-gradient-to-b from-slate-600 to-slate-800 rounded-b-xl"></div>
//           <div className="w-56 h-4 bg-gradient-to-b from-slate-700 to-slate-900 rounded-full mx-auto shadow-lg"></div>
//         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Interaction Guide */}
//                         <div className="mt-6 bg-blue-50 rounded-lg p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-6 h-6 lg:w-8 lg:h-8 bg-blue-600 text-white rounded-full flex items-center justify-center">
//                                     <span className="text-sm">✈️</span>
//                                 </div>
//                                 <div>
//                                     <h4 className="font-semibold text-blue-900 text-sm lg:text-base">Interactive Travel Flow</h4>
//                                     <p className="text-xs lg:text-sm text-blue-700">Click on destination cards to explore offers and book your perfect Eid getaway</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Sidebar - Details */}
//                 <div className="lg:col-span-1 order-3">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6 mb-4 lg:mb-6">
//                         <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-4">Creative Details</h3>
                        
//                         <div className="space-y-3 lg:space-y-4">
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Dimensions</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">320 × 600px</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Format</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">Interactive HTML5</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Interaction</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">Multi-Step Flow</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">File Size</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">3.2 MB</div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Performance Metrics */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Engagement Stats</h3>
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Selection Rate</span>
//                                 <span className="text-sm font-semibold text-green-600">12.4%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Flow Completion</span>
//                                 <span className="text-sm font-semibold text-blue-600">8.7%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Booking Rate</span>
//                                 <span className="text-sm font-semibold text-purple-600">5.2%</span>
//                             </div>
//                         </div>
//                     </div>

                   

                   
                   
//                 </div>
//             </div>
//         </div>
//     );
// }
